import { render, staticRenderFns } from "./AdministrativePlan.vue?vue&type=template&id=1cc62406"
import script from "./AdministrativePlan.vue?vue&type=script&lang=js"
export * from "./AdministrativePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports